import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeRoofDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHomeRoofDoor"><Path d="M22.8955 9.57031L21.7314 11.1963L20 9.95703V21H14V14H10V21H4V9.95703L2.26855 11.1963L1.10449 9.57031L12 1.76953L22.8955 9.57031Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeRoofDoor;
